import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import { Form, Input } from 'antd'
import React from 'react'

const CustomTableSearch = ({onSearchTable}) => {
  return (
    <div className="customSearchBox" style={{marginBottom:'-20px'}}>
        <Form.Item name="search" >
            <Input placeholder=" Search ..." size="large" onChange={(e) => onSearchTable(e)} prefix={<SearchOutlined />} allowClear className="table-search-box" />
        </Form.Item>
    </div>
  )
}

export default CustomTableSearch